import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexDetails',
  setup(__props) {

const BlogShadow = defineAsyncComponent(() => import("@/components/theme/blog/details/BlogShadow.vue"))
const BlogList = defineAsyncComponent(() => import("@/components/theme/blog/details/BlogList.vue"))
const BlogGrid = defineAsyncComponent(() => import("@/components/theme/blog/details/BlogGrid.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Blog",
      mains: "Blog details",
      title: "Blog details"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BlogShadow)),
        _createVNode(_unref(BlogList)),
        _createVNode(_unref(BlogGrid))
      ])
    ])
  ], 64))
}
}

})